import React, { useEffect, useState } from 'react';

import { Stack, Typography, Link, Box } from '@mui/material';

import { Loader } from 'components/Loader';
import { ListItem } from '../components/ListItem';
import { useGetAll } from '../api/getAll';
import { paths } from 'routes';
import { Link as RouterLink } from 'react-router-dom';
import { IconWrapper } from 'components/Icon';

export const RecentBlogPosts = ({currentPostID}) => {
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);

  const {
    data: { blogs, total },
    refetch: refetchBlogs,
    isFetching,
  } = useGetAll({
    page: 0,
    limit: 3,
    queryOptions: {
      onSettled: () => {
        clearTimeout(timer);
        setTimeout(() => setLoading(false), 1000);
      }
    },
  });

  useRefetch();

  useEffect(() => {
    if (isFetching) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [isFetching]);

  if (!blogs || blogs.length === 0) {
    return null;
  }

  return (
      <Stack
        sx={{
          display: "flex",
          gap: 5,
          maxWidth: "100vw",
          alignItems: {xs: "center", md: "flex-start"},
          mt: 5,
        }}
      >
        <Stack gap={2} flexDirection={{xs: "column", md: "row"}} sx={{mx: {xs:4, md: 0}}}>      
          <Typography
            flex={1}
            variant='h2'
            sx={{
              fontSize: "2rem",
              fontWeight: 600,
              lineHeight: 1.25,
              alignSelf: "center",
              textAlign: {xs: "center", md: "start"},
            }}
          >
            You may also be interested in
          </Typography>
        </Stack>
          {isFetching && !loading ? 
          (
            <></>
          ) :
          (!isFetching || (isFetching && loading)) ?
          (
            <>
            {loading && (
              <Loader style={{ marginTop: "20vh"}}/>
            )}
          
            {!loading && (
              <Stack flexDirection={"column"} gap={1} width={1} maxWidth={{xs: 366, md: "none"}} boxSizing={"border-box"} sx={{mx: {xs:4, md: 0}, minWidth: 0, display: 'flex'}}>
                <Stack flexDirection={{xs: "column", md: "row"}} gap={2} sx={{minWidth: 0}}>
                  {blogs.length !== 0 && (
                    blogs
                      .filter((item) => item.blog_id !== Number(currentPostID))
                      .slice(0, 2)
                      .map((item) => (
                        <ListItem key={item.blog_id} {...item} />
                      ))
                  )}
                </Stack>
                <Box>
                  <Link
                    component={RouterLink}
                    to={paths.blog}
                    color="primary.light"
                    sx={{height:1}}
                  >
                    <Stack sx={{justifyContent: {xs: "flex-start", md: "flex-end"}, flexDirection: "row", gap: 1}}>
                      <Typography>
                        See more
                      </Typography>
                      <IconWrapper
                        icon="arrowRightLong"
                        sx={({ palette }) => ({
                          svg: {
                            color: palette.primary.light,
                            stroke: palette.primary.light,
                            width: 20,
                            height: 20,
                          },
                        })}
                      />
                    </Stack>
                  </Link>
                </Box>
              </Stack>
            )}
            </>
          ) :
          (
            <></>
          )}
        </Stack>
  );

  function useRefetch() {
    useEffect(() => {     
      refetchBlogs();
    }, [page]);
  }
};
